import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { FaChevronLeft } from "react-icons/fa6";
import { Link } from "react-router-dom";
import MyBookingsList from "./MyBookingsList";
import Jobs from "../../ServiceProvider/Jobs";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedBookingListStatus } from "../../../store/common/bookingSlice";

const Bookings = () => {
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState(null);

  const user = useSelector((state) => state?.auth?.loggedInUser);
  const selectedBookingListStatus = useSelector(
    (state) => state?.booking?.selectedBookingListStatus,
  );

  const spOptions = [
    {
      id: 1,
      label: "My Jobs",
    },
    {
      id: 2,
      label: "My Bookings",
    },
  ];

  const handleBookingOptions = (option) => {
    setSelectedOption(option);
  };

  useEffect(() => {
    setSelectedOption(
      user && user?.type.toLowerCase() == "service user"
        ? spOptions[1]
        : spOptions[0],
    );
  }, []);

  return (
    <Row>
      <Col span={24} className="md:px-20 sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6">
        {user && user?.type && user?.type.toLowerCase().includes("user") ? (
          <div className="mb-4 flex justify-between items-center">
            <h5 className="heading-5 text-slate-600 font-semibold">
              My Bookings
            </h5>
            <Link to="/" className="cursor-pointer flex items-center">
              <FaChevronLeft className="text-primary bg-white p-2 rounded-full text-3xl" />
              <small className="ml-2 font-medium">Back</small>
            </Link>
          </div>
        ) : (
          <div
            className="sm:mb-3 mb-6 pr-2 flex justify-between w-full"
            id="booking-list"
          >
            <div className="sm:w-2/5 w-full">
              {spOptions.map((option) => (
                <span
                  key={option?.id}
                  className={`${selectedOption && selectedOption.id == option?.id ? "bg-primary text-white" : "bg-[#FEEDBF] text-black"} 
                                text-xs p-3 font-semibold rounded-sm cursor-pointer inline-block sm:w-[120px] text-center`}
                  onClick={() => handleBookingOptions(option)}
                >
                  {option?.label}
                </span>
              ))}
            </div>
            {selectedBookingListStatus ? (
              <div
                className="cursor-pointer flex items-center"
                onClick={() => dispatch(setSelectedBookingListStatus(null))}
              >
                <FaChevronLeft className="text-primary bg-white p-2 rounded-full text-3xl" />
                <small className="ml-2 font-medium">Back to My Calendar</small>
              </div>
            ) : (
              ""
            )}
          </div>
        )}

        <div className="md:mb-4 sm:mb-4 mb-6 pr-2" id="booking-list">
          {selectedOption && selectedOption?.id == 1 ? (
            <Jobs />
          ) : selectedOption?.id == 2 ? (
            <MyBookingsList />
          ) : (
            ""
          )}
        </div>
      </Col>
    </Row>
  );
};

export default Bookings;
